import { BellOutlined, EnvironmentOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { getStaticUrl } from "../../../../../utils";
import { FCRodinaButton } from "../../../../../components/Button";

export const CitiesButtons = () => {
    return (
        <div className="flex flex-col sm:flex-row items-center py-4 gap-2">
            <FCRodinaButton
                icon={<EnvironmentOutlined />}
                onClick={() => window.open('https://vk.com/video/playlist/-191701576_11')}
                className="w-full sm:w-fit !rounded-full sm:!rounded !py-3"
            >
                Прошедшие выезды
            </FCRodinaButton>
            <FCRodinaButton
                icon={<BellOutlined />}
                onClick={() => window.open('https://t.me/s/fcrodina?q=%23%D0%93%D0%BE%D1%80%D0%BE%D0%B4%D0%B0%D0%A0%D0%BE%D0%B4%D0%B8%D0%BD%D1%8B')}
                className="w-full sm:w-fit !rounded-full sm:!rounded !py-3"
            >
                Новости
            </FCRodinaButton>
            <FCRodinaButton
                icon={<InfoCircleOutlined />}
                onClick={() => window.open(getStaticUrl('/uploads/docs/CitiesPromoRules.pdf'))}
                className="w-full sm:w-fit !rounded-full sm:!rounded !py-3"
            >
                Полные правила конкурса
            </FCRodinaButton>
        </div>
    );
};